// extracted by mini-css-extract-plugin
module.exports = {"switch":"Switch_switch__275wZ","background":"Switch_background__DCc8K"};